import { useNavigate } from 'react-router-dom'
import { styled } from '../../../lib/stitches'
import Button from '../../core/Button/Button'
import Text from '../../core/Text/Text'

const segmentMarketingPage = (button: string) => {
  window.analytics.track('Button Clicked', {
    button: button,
    location: 'marketing page',
    source: window.location.pathname
  })
}
export const GuaranteeWrapper = styled('section', {
  padding: '72px 0',
  width: '100%',
  backgroundColor: '#000',
  color: '#fff',
  '@tablet': {
    display: 'flex',
    justifyContent: 'center',
    padding: '156px 0 215px'
  }
})

export const Box = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px',
  textAlign: 'center',
  '@tablet': {
    maxWidth: '350px',
    padding: 0,
    alignItems: 'flex-start',
    textAlign: 'start'
  }
})

export const ImgWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  overflow: 'hidden',
  marginBottom: '48px',
  '@tablet': {
    marginBottom: 0,
    marginRight: '156px'
  }
})

const Guaranteed = () => {
  const navigate = useNavigate()

  return (
    <GuaranteeWrapper>
      <ImgWrapper
        css={{
          '@laptop': {
            display: 'none'
          }
        }}
      >
        <img
          src="/static/images/acoustic-guitar-mobile.png"
          alt="acoustic guitrar"
          style={{ maxWidth: '100%' }}
        />
      </ImgWrapper>
      <ImgWrapper
        css={{
          display: 'none',
          '@laptop': {
            display: 'flex'
          }
        }}
      >
        <img
          src="/static/images/acoustic-guitar-desktop.png"
          alt="acoustic guitrar"
          style={{ maxWidth: '575px' }}
        />
      </ImgWrapper>
      <Box>
        <Text
          size="32"
          fontWeight="semibold"
          css={{
            letterSpacing: '-0.3px',
            lineHeight: '36px',
            color: '$gray02'
          }}
        >
          Guaranteed credit when your sound is used.
        </Text>
        <Text
          size="16"
          fontWeight="regular"
          css={{
            letterSpacing: '-0.3px',
            lineHeight: '28px',
            color: '$gray07',
            margin: '16px 0 30px'
          }}
        >
          Arpeggi Studio uses blockchain technology to track who, where, and how your sounds have
          been used.
        </Text>
        <Button
          type="white"
          css={{
            padding: '0 20px',
            height: '40px',
            fontSize: '16px',
            borderRadius: '10px',
            fontWeight: 500
          }}
          onClick={() => {
            segmentMarketingPage('Explore Sounds')
            navigate('/home/songs')
          }}
        >
          Explore sounds
        </Button>
      </Box>
    </GuaranteeWrapper>
  )
}

export default Guaranteed
